<div class="container" id="main-content" aria-label="Main Content">

    <div class="row">
        <h2 class="col-sm-12 text-center" tabindex="0">{{'COMMON.SESSION_TIMEOUT' | translate}}</h2>
    </div>
    <br />
    <div class="row">
        <h5 class="col-sm-12 text-center" tabindex="0">{{'COMMON.RESTART_APPLICATION' | translate}}</h5>
    </div>
    <br />
    <div class="row">
        <button class="btn btn-primary restart-btn" (click)="restart()"
            tabindex="0">{{'COMMON.RESTART' | translate}}</button>
    </div>
</div>